<section class="tw-bg-white tw-border tw-rounded-lg tw-p-4 tw-mb-3">
  <div class="tw-flex tw-gap-4">
    <form [formGroup]="form" [id]="identifier()" class="tw-w-full tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-items-center tw-justify-start">
      <div class="tw-col-span-1 tw-px-2 tw-mb-3">
        <label class="tw-block tw-text-sm tw-text-gray-700 tw-mb-1">Persona</label>
        <label
          class="tw-block tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md tw-bg-gray-50 tw-overflow-auto tw-whitespace-nowrap tw-text-ellipsis"
          [ngxTippy]="persona()?.name"
          >{{ persona()?.name }}</label
        >
      </div>
      <!-- Session -->
      <div class="tw-col-span-1 tw-px-2 tw-mb-3">
        <label [for]="identifier() + '-session-code'" class="tw-block tw-text-sm tw-text-gray-700 tw-mb-1">Session</label>
        <div [ngxTippy]="sessionName() || null">
          <select
            [id]="identifier() + '-session-code'"
            [ngClass]="{ 'tw-cursor-not-allowed': !form.get('session')?.enabled }"
            formControlName="session"
            type="text"
            class="tw-appearance-none tw-text-ellipsis tw-select-input tw-block tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-blue-500 disabled:tw-bg-gray-200"
            placeholder="Enter DCT Event ID"
            required
          >
            <option value="" disabled>Select a session</option>
            @for (session of sessions(); track session.id) {
            <option [value]="session.code">{{ session.name }}</option>
            }
          </select>
        </div>
      </div>
      <!-- /Session -->
      <!-- Session slot -->
      <div class="tw-col-span-1 tw-px-2 tw-mb-3">
        <label [for]="identifier() + '-session-slot'" class="tw-block tw-text-sm tw-text-gray-700 tw-mb-1">Session slot</label>
        <div [ngxTippy]="sessionSlotName() || null">
          <select
            [id]="identifier() + '-session-slot'"
            [ngClass]="{ 'tw-cursor-not-allowed': !form.get('sessionSlot')?.enabled }"
            formControlName="sessionSlot"
            type="text"
            class="tw-appearance-none tw-text-ellipsis tw-block tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-blue-500 disabled:tw-bg-gray-200"
            placeholder="Enter DCT Event ID"
            required
          >
            <option value="" disabled>Select a session slot</option>
            @for (sessionSlot of sessionSlots(); track sessionSlot.id) {
            <option [value]="sessionSlot.code">{{ sessionSlot.name }}</option>
            }
          </select>
        </div>
      </div>
      <!-- /Session slot -->
      <!-- Product -->
      <div class="tw-col-span-1 tw-px-2 tw-mb-3">
        <label [for]="identifier() + '-product-code'" class="tw-block tw-text-sm tw-text-gray-700 tw-mb-1">Product</label>
        <div [ngxTippy]="productName() || null">
          <select
            [id]="identifier() + '-product-code'"
            [ngClass]="{ 'tw-cursor-not-allowed': !form.get('product')?.enabled }"
            formControlName="product"
            type="text"
            class="tw-appearance-none tw-text-ellipsis tw-block tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-blue-500 disabled:tw-bg-gray-200"
            placeholder="Enter DCT Event ID"
            required
          >
            <option value="" disabled>Select a product</option>
            @for (product of products(); track product.id) {
            <option [value]="product.code">{{ product.name }}</option>
            }
          </select>
        </div>
      </div>
      <!-- /Product -->
      <!-- Product variant -->
      <div class="tw-col-span-1 tw-px-2 tw-mb-3">
        <label [for]="identifier() + '-product-variant'" class="tw-block tw-text-sm tw-text-gray-700 tw-mb-1">Product variant</label>
        <div [ngxTippy]="productVariantName() || null">
          <select
            [id]="identifier() + '-product-variant'"
            [ngClass]="{ 'tw-cursor-not-allowed': !form.get('productVariant')?.enabled }"
            formControlName="productVariant"
            type="text"
            class="tw-appearance-none tw-text-ellipsis tw-block tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-blue-500 disabled:tw-bg-gray-200"
            placeholder="Enter DCT Event ID"
            required
          >
            <option value="" disabled>Select a product variant</option>
            @for (productVariant of productVariants(); track productVariant.id) {
            <option [value]="productVariant.code">{{ productVariant.name }}</option>
            }
          </select>
        </div>
      </div>
      <!-- /Product variant -->
      <!-- Price -->
      <div class="tw-col-span-1 tw-px-2 tw-mb-3">
        <label [for]="identifier() + '-price'" class="tw-block tw-text-sm tw-text-gray-700 tw-mb-1">Price</label>
        <input
          [id]="identifier() + '-price'"
          [ngClass]="{ 'tw-cursor-not-allowed': !form.get('price')?.enabled }"
          formControlName="price"
          type="text"
          class="tw-block tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md disabled:tw-bg-gray-200"
        />
      </div>
      <!-- /Price -->
    </form>
  </div>
  <div class="tw-flex tw-justify-end">
    @if (!isConnected()) {
    <button
      [class]="{ 'tw-opacity-50 tw-cursor-not-allowed': !form.valid }"
      class="tw-px-4 tw-py-2 tw-bg-blue-600 tw-text-white tw-rounded-md hover:tw-bg-blue-700 focus:tw-outline-blue-500 focus:tw-ring-offset-2 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
      (click)="connect()"
    >
      Connect
    </button>
    } @else {
    <button
      [class]="{ 'tw-opacity-50 tw-cursor-not-allowed': !form.valid && !isConnected() }"
      class="tw-px-4 tw-py-2 tw-bg-red-600 tw-text-white tw-rounded-md hover:tw-bg-red-700 focus:tw-ring-2 focus:tw-ring-red-500 focus:tw-ring-offset-2 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
      (click)="disconnect()"
    >
      Disconnect
    </button>
    }
  </div>
</section>
